import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
  STATE_COOKIEBANNER,
  setCookieBanner,
  setConsent,
  STATE_CONSENT,
} from "../../common/state";
import { Title, Button } from "@mantine/core";
import classes from "./cookieBanner.module.css";

const CookieBanner = (props) => {
  const dispatch = useDispatch();
  const handleClick = () => dispatch(setCookieBanner());
  const getConsentValue = useSelector((state) => state.cookies[STATE_CONSENT]);
  const language = useSelector((state) => state.language);
  const showConsentBanner = useSelector((state) => state.config);
  const showCookieBanner = useSelector(
    (state) => state.cookies[STATE_COOKIEBANNER]
  );
  const handleConsent = (value) => dispatch(setConsent(value));
  const handleConsentDialog = (value) => {
    handleConsent(value);
    handleClick();
  };
  if (getConsentValue !== "null") return null;
  return (
    <>
      {showCookieBanner !== "false" &&
      getConsentValue === "null" &&
      showConsentBanner.useTagmanager === true ? (
        <div
          className={`${classes.container} cookieContainer`}
          role="dialog"
          aria-modal="false"
          aria-labelledby="cookie-box-title"
          aria-describedby="cookie-box-message"
        >
          <Title order={2} size="large" id="cookie-box-title">
            {language.CookieSettings}
          </Title>
          <p className={classes.cookieText} id="cookie-box-message">
            {language.WeUseCookies}{" "}
            <Link className="cookieLink" to="/security">
              {language.Cookies}
            </Link>{" "}
            {language.CookieConsentBody}
          </p>
          <div className={classes.cookieButtonContainer}>
            <motion.div
              whileTap={{ scale: 1.1 }}
              className={classes.actionButtonContainer}
            >
              <Button
                color="secondary"
                className="declineButton"
                onClick={() => handleConsentDialog(false)}
              >
                {language.CookieDecline.toUpperCase()}
              </Button>
            </motion.div>

            <motion.div
              whileTap={{ scale: 1.1 }}
              className={classes.actionButtonContainer}
            >
              <Button
                className="consentButton"
                onClick={() => handleConsentDialog(true)}
              >
                {language.CookieConsent.toUpperCase()}
              </Button>
            </motion.div>
          </div>
        </div>
      ) : (
        ""
      )}

      {showCookieBanner !== false &&
      showCookieBanner !== "false" &&
      showConsentBanner.useTagmanager === false ? (
        <div
          className={`${classes.container} cookieContainer`}
          role="dialog"
          aria-modal="false"
          aria-labelledby="cookie-box-title"
          aria-describedby="cookie-box-message"
        >
          <Title order={2} size="large" id="cookie-box-title">
            {language.CookieSettings}
          </Title>
          <p className={classes.cookieText} id="cookie-box-message">
            {language.FunctionalCookies}{" "}
            <Link className="cookieLink" to="/security">
              {language.Cookies}
            </Link>{" "}
            {language.OnSiteCookies}
          </p>
          <div className={classes.cookieButtonContainer}>
            <motion.div
              whileTap={{ scale: 1.1 }}
              className={classes.actionButtonContainer}
            >
              <Button className="consentButton" onClick={handleClick}>
                {language.CookieSimpleConsent}
              </Button>
            </motion.div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default CookieBanner;
